import { render, staticRenderFns } from "./NDVDraggablePanels.vue?vue&type=template&id=e951ca82&"
import script from "./NDVDraggablePanels.vue?vue&type=script&lang=ts&"
export * from "./NDVDraggablePanels.vue?vue&type=script&lang=ts&"
import style0 from "./NDVDraggablePanels.vue?vue&type=style&index=0&id=e951ca82&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports